/* eslint-disable react/no-unknown-property */
import { useLoader } from '@react-three/fiber';
import { ControlContext } from 'provider/ControlProvider';
import { Suspense, useContext } from 'react';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';

type Props = {
  orbit: any;
};
export default function Model({ orbit }: Props) {
  const { gender } = useContext(ControlContext);
  const { scene: model } = useLoader(
    GLTFLoader,
    gender ? 'model/finalFemale.glb' : 'model/finalMale.glb'
  );

  return (
    <group>
      <primitive hidden={gender} object={model} />
    </group>
  );
}
